import React from 'react';
import { Route, Switch, type SwitchProps } from 'react-router';
import type { Langcodes } from '@uncinc/react-drupal-core/types';

import Entity from '../Entity';
import Search from '../Search';
import CustomRoute from './Custom';

interface RoutesProps extends SwitchProps {
  language: Langcodes;
}

const Routes: React.FC<RoutesProps> = ({ language, ...props }) => (
  <Switch {...props}>
    {/* Add routes here */}
    <CustomRoute path={`/${language}/:path(zoeken|search)`} render={() => (<Search />)} />
    <Route render={() => (<Entity />)} />
  </Switch>
);

export default Routes;
